<template>
    <div class="jump-usercenter nav-bar-fixed" style="padding: 10px;">
        <van-nav-bar title="获取积分途径" left-arrow fixed @click-left="back"/>
        <div v-html="content" id="content" ref="content"></div>
        <!-- <img src="../../assets/rule.png" style="width: 100%;height: auto;"/> -->
        <!-- <van-row>
             1、签到获取：会员每日登录聚牧城系统第一次签到，赠送积分；
         </van-row>


         <van-row>
             2、会员分享获取：会员登录后可通过手机APP、微信端将商品分享至朋友圈，赠送会员积分；
         </van-row>

         <van-row>
             3、推荐会员首次获取：已注册会员推荐非会员注册成功，根据后台配置-推荐赠送积分，赠送推荐会员和被推荐会员积分；
         </van-row>

         <van-row>
             4、推荐会员首单获取：被推荐会员首次下单成功，赠送推荐会员和被推荐会员积分；
         </van-row>

         <van-row>
             5、小游戏获取：会员通过参与小游戏砸金蛋、大转盘获取到的积分；
         </van-row>

         <van-row>
             6、购买下单赠送积分商品赠送积分；
         </van-row>

         <van-row>
             7、购买活动商品赠送积分，赠送积分；
         </van-row>

         <van-row>
             8、会员生日获取：会员生日当天，根据后台积分配置-生日赠送积分规则，赠送会员积分；
         </van-row>

         <van-row>
             9、会员节日获取：节日当天，根据后台会员积分配置-节日赠送积分规则，赠送会员积分；
         </van-row>

         <van-row>
             10、目标达成获取：会员消费金额达到一定金额赠送对应的积分；
         </van-row>

         <van-row>
             11、内部员工目标达成获取：计算员工审批平均时效，赠送对应的积分；
         </van-row>

         <van-row>
             12、目标达成获取:会员完善个人资料中的：姓名、电话、生日、收货地址，赠送会员积分；
         </van-row>-->

        </div>
</template>
<script>
    import {
        NavBar,
        Row,
        Col,
        Field,
        Button,
        Popup,
        Picker,
        Cell,
        CellGroup,
        RadioGroup,
        Radio,
        DatetimePicker
    } from "vant";


    export default {
        name: "userinfo",
        components: {
            [NavBar.name]: NavBar,
            [Row.name]: Row,
            [Col.name]: Col,
            [Field.name]: Field,
            [Button.name]: Button,
            [Popup.name]: Popup,
            [Picker.name]: Picker,
            [Cell.name]: Cell,
            [CellGroup.name]: CellGroup,
            [RadioGroup.name]: RadioGroup,
            [Radio.name]: Radio,
            [DatetimePicker.name]: DatetimePicker
        },
        data() {
            return {
                content:''
            };
        },
        mounted() {
              this.$api.get(this.jumuc.articleByMark, {param:'appExchange'},
                successRes => {
                       if (successRes.success) {
                           this.content=successRes.data.jmArticle.content;
                           this.$nextTick(function(){
                             console.log(this.$refs.content)
                           })
                         
                           document.querySelector('#content img').style.width='100%'
                       }
                })
        },
        updated (){
            var obj=this.$refs.content.getElementsByTagName("img")[0];
            obj.style.width='100%';
            obj,style.height='auto%'
        },
        methods: {

            back() {
                history.back();
            }

        },
    };
</script>
<style lang="less" scoped>
// #content img{
//     width:100%!important
// }
    @bule-thame: #3c6eeb;
    .jump-usercenter {
        padding-top: 50px;
        button {
            background-color: @bule-thame;
            border-color: @bule-thame;
        }
        .usercenter-button {
            padding: 0 15px;
            button {
                background-color: @bule-thame;
                color: white;
                font-weight: 700;
                border-radius: 5px;
                margin: 25px 0 10px;
            }
        }

        .van-radio-group {
            .van-cell__title {
                max-width: 90px;
            }
            .van-cell__value {
                text-align: left;
                .van-radio {
                    display: inline-block;
                    margin-right: 15px;
                }
            }
        }
    }
</style>

